var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationReport = function SvgGeneralInformationReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.456 9.226v4.967h1.8v6H6.305a2.553 2.553 0 0 1-2.55-2.55v-3.45h1.8V9.226c0-3.39 2.894-6.15 6.45-6.15s6.45 2.76 6.45 6.15m-11.401 0c0-2.564 2.22-4.65 4.95-4.65s4.95 2.086 4.95 4.65v4.967h-9.9zm11.7 9.467H6.306c-.578 0-1.05-.47-1.05-1.05v-1.95h13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.256 11.585h1.5v-3.6h-1.5z"
  }))));
};
export default SvgGeneralInformationReport;